import { createReducer } from '../../app/common/util/reducerUtil';
import { DELETE_OTP, GENERATE_OTP, VERIFY_OTP } from './OTPconstants';

const initialState = {};

export const generateOTP = (state, payload) => {
  return {
    ...state,
    ...payload,
  };
};

export const deleteOTP = (state, payload) => {
  return payload;
};

export const verifyOTP = (state, payload) => {
  return {
    ...state,
    ...payload,
  }
};


export default createReducer(initialState, {
  [GENERATE_OTP]: generateOTP,
  [DELETE_OTP]: deleteOTP,
  [VERIFY_OTP]: verifyOTP,
});

